import { useEffect } from "react";

import { LISCase, LISDocument } from "pwapi";

import { useIsLoadingAny } from "shared/hooks/requestStatusHooks";

import { loadStationDocument } from "app/actions/documentActions";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { useSelectedLab } from "hooks/useSelectedLabStation";
import Spinner from "ui/components/Spinner";

const StationDocument = ({
  documents,
  category = LISDocument.category.REQUISITION_FORM,
}: {
  documents: LISCase["documents"];
  category?: LISDocument.category;
}) => {
  const dispatch = useAppDispatch();
  const lab = useSelectedLab();
  const { document, open } = useAppSelector(({ ui }) => ui.stationDocument);
  const loading = useIsLoadingAny(loadStationDocument);

  const documentId = documents
    .filter((d) => d.category === category && d.status === "uploaded")
    .at(0)?.id;

  useEffect(() => {
    documentId && dispatch(loadStationDocument({ id: documentId }));
  }, [documentId]);

  return (
    <div
      className="StationDocument"
      style={{
        width: "40%",
        ...(lab?.settings?.paperless_grossing?.details as {}),
      }}
    >
      {!documentId ? (
        <div className="StationDocument__message">
          <p>
            <em>No {category} has been scanned</em>
          </p>
        </div>
      ) : document?.presigned_url && open && !loading ? (
        <iframe
          src={document?.presigned_url}
          title={document?.name}
          width="100%"
          height="100%"
        />
      ) : loading ? (
        <div className="StationDocument__message">
          <Spinner />
        </div>
      ) : null}
    </div>
  );
};

export default StationDocument;
